// extracted by mini-css-extract-plugin
module.exports = {"formInput":"OperationCostsCard_formInput__3WbwA"};